import { render } from "./ArtworkWorkflowTracker.vue?vue&type=template&id=4af89cac&scoped=true"
import script from "./ArtworkWorkflowTracker.vue?vue&type=script&lang=js"
export * from "./ArtworkWorkflowTracker.vue?vue&type=script&lang=js"

import "./ArtworkWorkflowTracker.vue?vue&type=style&index=0&id=4af89cac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af89cac"]])

export default __exports__